import api from '@/services/api';

/**
 * Registra um aceite de termo no backend.
 * @param {'terms_of_use'|'payout_rules'|'checkout_disclaimer'|'event_creation_terms'} termType
 * @param {string} [guestEmail] - Obrigatório apenas para convidados não autenticados
 * @returns {Promise<void>}
 */
export async function logAcceptance(termType, guestEmail = null) {
  const payload = {
    term_type: termType,
    version: '1.0',
  };

  if (guestEmail) payload.guest_email = guestEmail;

  await api.post('/compliance/accept', payload);
}
